import i18next from 'i18next'
import type { VariantClassesProps } from '@shared-ui/utils'
import type { Meta } from 'shared/lib'

export type UserRole = 'admin' | 'user'

interface Tokens {
    accessToken: string
    refreshToken: string
}

export type User = {
    id: number
    firstName: string
    lastName: string
    email: string
    password: string
    oib: string
    sex: string
    dateOfBirth: string
    citizenship: string
    placeOfBirth: string
    phoneNumber: string
    shirtSize: string
    imageKey: string
    tokens?: Tokens
    profileStatus?: string
    pastResults?: string
    unisportId?: number
    showProfilePhoto?: boolean
}

const getRoles = (): VariantClassesProps => ({
    'super-admin': i18next.t('roles:roles.super-admin'),
    'organization-admin': i18next.t('roles:roles.organization-admin'),
    'unit-admin': i18next.t('roles:roles.unit-admin'),
    'technical-delegate': i18next.t('roles:roles.technical-delegate'),
    technician: i18next.t('roles:roles.technician'),
    notetaker: i18next.t('roles:roles.notetaker'),
    'team-admin': i18next.t('roles:roles.team-admin'),
    'recreation-admin': i18next.t('roles:roles.recreation-admin'),
    'recreation-trainer': i18next.t('roles:roles.recreation-trainer'),
    'cms-admin': i18next.t('roles:roles.cms-admin'),
    'cms-editor': i18next.t('roles:roles.cms-editor'),
    admin: i18next.t('roles:roles.admin'),
})

export const Roles: VariantClassesProps = new Proxy({} as VariantClassesProps, {
    get: (_target, key: string) => getRoles()[key],
    ownKeys: () => Object.keys(getRoles()),
    getOwnPropertyDescriptor: (_target, key: string) => ({
        value: getRoles()[key as string],
        enumerable: true,
        configurable: true,
    }),
})
export interface Actor {
    firstName: string
    lastName: string
    imageKey: string
    id: string
    showProfilePhoto: boolean
    unisportId: number
}
export type HistoryData = {
    id: number
    actor: Actor
    createdAt: string
    content: string
    type: string
    field: string
    actorId: string
    userId: string
    displayType: string
    displayField: string
}

export type CommentsData = {
    id: number
    createdAt: string
    content: string
    context: string
    userId: string
    actor: Actor
    actorId: string
    studentStatusId: number
}

/** @deprecated Use `Meta` from 'shared/lib' directly */
export type MetaData = Meta

export type UserProfile = {
    meta: Meta
    id: string
    firstName: string
    lastName: string
    email: string
    profileStatus: string
    isVerified: boolean
    oib: string
    sex: string
    dateOfBirth: string
    citizenship: string
    placeOfBirth: string
    phoneNumber: string
    shirtSize: string
    imageKey: string
    createdAt: string
    updatedAt: string
}

export type RequestParams = {
    update: boolean
    page: number
    limit: number
    search: string
    status: string
}

// Student status types (moved from features/user/student-status-tab)

export type StudentStatusSeason = {
    id: string
    name: string
    dateStart: string
    dateEnd: string
    status: string
}

export type StudentStatusDocument = {
    id: number
    studentStatusId: number
    key: string
    type: string
}

export type StudentStatusComment = {
    id: number
    createdAt: string
    content: string
    context: string
    userId: string
    actorId: string
    studentStatusId: number
}

export type StudentStatus = {
    id: number
    userId: string
    seasonId: string
    unitName: string
    fullName: string
    organizationName: string
    authorizedByName: string
    authorizedUntil: string
    season: StudentStatusSeason
    documents: Array<StudentStatusDocument>
    comments: Array<StudentStatusComment>
}

export type StudentStatusListData = Array<StudentStatus>
